import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  listItem: {
    padding: '0 0 20px 0',
    display: 'block',
  },
}));
